import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(false);
  private messageSubject = new BehaviorSubject<string>('Cargando...');
  
  loading$: Observable<boolean> = this.loadingSubject.asObservable();
  message$: Observable<string> = this.messageSubject.asObservable();

  /**
   * Muestra el spinner de carga global
   * @param message Mensaje opcional a mostrar
   */
  show(message: string = 'Cargando...'): void {
    this.messageSubject.next(message);
    this.loadingSubject.next(true);
  }

  /**
   * Oculta el spinner de carga global
   */
  hide(): void {
    this.loadingSubject.next(false);
    this.messageSubject.next('Cargando...');
  }

  /**
   * Obtiene el estado actual del loading
   */
  isLoading(): boolean {
    return this.loadingSubject.value;
  }
}
